import {
  getStatusIndicator,
  getStatusText
} from '@/components/EventSettings/EventSettingsActions/EventSettingsActionsStatus/EventSettingsActionsStatusIndicators/EventSettingsActionsStatusIndicators.helpers'
import { EventPipelineStatus } from '@/types/streams/eventPipelineStatus'

const EventSettingsActionsStatus = ({
  pipelineStatus,
  service,
  index
}: {
  pipelineStatus: EventPipelineStatus | null
  service: 'pipeline' | 'channel' | 'flow'
  index?: number
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {getStatusIndicator(service, pipelineStatus, index)}
      {getStatusText(service, pipelineStatus, index)}
    </div>
  )
}

export default EventSettingsActionsStatus
